<template>
  <div  v-if="userType == 'ADMIN'" style="justify-content: center; display: flex; padding-top: 30px; font-weight: bold; font-size: 24px;">
    Coming Soon...
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { getUserData } from '@/auth/utils'
import axios from 'axios'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: '',
      password: '',
      status: '',
      // validation rules
      required,
      email: '',
      users: [],
      showPage: false,
      userData : [],
      displayErrors: null,
      custDis: '',
      firstName: '',
      lastName: '',
      showSuccess: false,
      userType: 'REG',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    isMobile() {
       if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
         return true
       } else {
         return false
       }
     },
    showSuccessMessage(userData) {
      this.showSuccess = true
    },
    setError(error) {
      console.log('error: ' + error)
      this.displayErrors = error
    }
  },
  mounted() {
    const userData = JSON.parse(getUserData())
    this.userType = userData.permissions
    if (this.userType != 'ADMIN') {
      this.$router.push('/error-404')
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
